module.exports = __webpack_public_path__ + "static/deep_dive-c8f2a7cdd2c16fd8d379ad49bcf58f26.png";